import React from "react";
import { Container } from "react-bootstrap";
import {Link} from 'react-router-dom';

const Notfound =()=>{
    return(
        <>
            
            <div className="container-fluid vh-100 d-flex justify-content-center align-items-center bg-light">
            <Container>
      <div className="text-center">
        <h1 className="display-1 texteYantra">404</h1>
        <h2 className="h3 mb-4">Page Not Found</h2>
        <p className="lead mb-4">Oops! The page you're looking for doesn't exist.</p>
        <Link to="/" className="text-decoration-none" id="btnCTA">Go back to Home</Link>
      </div>
      </Container>
    </div>
            
        </>
    )
}

export default Notfound;